import styles from './ProgressDots.module.css';

const ProgressDots = ({ totalSteps, currentStep }) => {

	return (
		<div className={styles.progressDots}>
			{Array.from({ length: totalSteps }).map((_, index) => {
				let dotStatus;
				if (index < currentStep - 1) {
					dotStatus = 'completed';
				} else if (index === currentStep - 1) {
					dotStatus = 'current';
				} else {
					dotStatus = 'pending';
				}

				return (
					<div
						key={index}
						className={`${styles.dot} ${styles[dotStatus]}`}
					/>
				);
			})}
		</div>
	);
};

export default ProgressDots;